import {Button} from 'antd';
import React, {useEffect, FC} from 'react';

import {DynamicIcon, TIconType} from 'components/dynamic-icon/dynamic-icon';
import {setDataIsEditable} from 'modules/data/data-actions';
import {selectIsFormEntityDataEditable} from 'modules/data/data-selectors';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

interface IOwnProps {
    entityName: string;
    actionTitle?: string;
    actionIcon?: TIconType;
}

export const ButtonEditForm: FC<IOwnProps> = ({
    entityName,
    actionTitle,
    actionIcon,
}: IOwnProps) => {
    const dispatch = useAppDispatch();
    const editableSelector = selectIsFormEntityDataEditable(entityName);
    const isEditable = useAppSelector(state => editableSelector(state));

    const setIsEditable = (editable: boolean) => {
        dispatch(setDataIsEditable({entityName, entityType: EEntityType.FORM, isEditable: editable}));
    };

    useEffect(() => {
        setIsEditable(false);
    }, []);

    return (
        <Button
            onClick={() => setIsEditable(!isEditable)}
            type="primary"
            style={{width: '100%'}}
        >
            {actionIcon && <DynamicIcon type={actionIcon} />}
            {actionTitle}
        </Button>
    );
};
